var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DecimalFilter_1;
import { JsonSchemaV2, JSON, JsonDiscriminatorValue } from '@symon-ai/wisepipe-serialize';
import { squel } from '@symon-ai/wisepipe-squel';
import { FilterType, Filter, Closed } from './filter';
import { decimalFilterSchemaValidation } from '../validations.generated';
export const decimalFilterSchema = {
    $id: 'urn:wisepipe-common-computation:DecimalFilter',
    type: 'object',
    properties: {
        values: {
            type: 'array',
            items: { type: ['string', 'null'] }
        }
    },
    if: {
        required: ['start', 'end']
    },
    then: {
        properties: {
            start: { type: 'string' },
            end: { type: 'string', minimum: { $data: '1/start' } },
            closed: { type: 'string', enum: Object.values(Closed) }
        }
    },
    else: {
        properties: {
            start: { type: 'string' },
            end: { type: 'string' }
        }
    }
};
let DecimalFilter = DecimalFilter_1 = class DecimalFilter extends Filter {
    constructor(column, start, end, values, closed) {
        super(column, FilterType.DECIMAL);
        if (start !== undefined)
            this.start = start;
        if (end !== undefined)
            this.end = end;
        if (closed !== undefined)
            this.closed = closed;
        // By default numberFilter has equals
        else
            this.closed = Closed.BOTH;
        if (values)
            this.values = values;
        JSON.validate(this, DecimalFilter_1);
    }
    get sql() {
        let startOperator = '>';
        let endOperator = '<';
        if (this.closed === Closed.LEFT || this.closed === Closed.BOTH)
            startOperator = '>=';
        if (this.closed === Closed.RIGHT || this.closed === Closed.BOTH)
            endOperator = '<=';
        const expr = squel.expr();
        let range;
        if (this.start !== undefined) {
            range = squel.expr();
            range.and(`"${this.column}" ${startOperator} ${this.start}`);
        }
        if (this.end !== undefined) {
            if (!range)
                range = squel.expr();
            range.and(`"${this.column}" ${endOperator} ${this.end}`);
        }
        if (range) {
            expr.or(range);
        }
        if (this.values) {
            this.values.forEach((v) => expr.or(this.getValueConstraint(v)));
        }
        return expr;
    }
    getValueConstraint(value) {
        const rhs = value === null ? 'IS NULL' : `= ${value}`;
        return `"${this.column}" ${rhs}`;
    }
};
DecimalFilter = DecimalFilter_1 = __decorate([
    JsonSchemaV2(decimalFilterSchema, decimalFilterSchemaValidation),
    JsonDiscriminatorValue(FilterType.DECIMAL)
], DecimalFilter);
export { DecimalFilter };
//# sourceMappingURL=decimalFilter.js.map